export type MediaType = "image" | "video";

const VIDEO_EXTENSIONS: string[] = ["mp4", "webm", "ogg", "ogv", "mov", "m4v", "mpeg", "mpg", "avi"];

function stripQueryAndHash(src: string): string {
  const [path] = src.split(/[?#]/);
  return path || src;
}

function extractExtension(src: string): string {
  const path = stripQueryAndHash(src).toLowerCase();
  const lastDot = path.lastIndexOf(".");
  if (lastDot === -1) {
    return "";
  }
  return path.slice(lastDot + 1);
}

export function resolveVideoMime(src: string): string {
  const ext = src.split(".").pop()?.toLowerCase() ?? "mp4";
  const mime: Record<string, string> = {
    mp4: "video/mp4",
    webm: "video/webm",
    ogg: "video/ogg",
    ogv: "video/ogg",
    mov: "video/quicktime",
    m4v: "video/x-m4v",
    mpeg: "video/mpeg",
    mpg: "video/mpeg",
    avi: "video/x-msvideo",
  };
  return mime[ext] ?? "video/mp4";
}

export function inferMediaType(src?: string): MediaType {
  if (!src) {
    return "image";
  }
  const ext = extractExtension(src);
  if (ext && VIDEO_EXTENSIONS.includes(ext)) {
    return "video";
  }
  return "image";
}


